import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-admin-page-shell',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './admin-page-shell.component.html',
  styleUrl: './admin-page-shell.component.scss',
})
export class AdminPageShellComponent {
  /** i18n key for the page title */
  titleKey = input.required<string>();
  /** Optional i18n key for subtitle */
  subtitleKey = input<string | null>(null);
  /** Wrap default slot in a standard admin panel card */
  panelled = input(true);
}
